import type moment from "moment";

export enum TimeSlotSelectFilterChoiceEnum {
    AllDay = "allDay",
    Lunch = "lunch",
    Dinner = "dinner",
    Custom = "custom",
}

export interface TimeSlotSelectFilterValue {
    serviceTime?: TimeSlotSelectFilterChoiceEnum;
    durationStartFromMidnight?: moment.Duration;
    durationEndFromMidnight?: moment.Duration;
}

export const SERVICE_TIME_HOURS = {
    LUNCH: { start: 5, end: 17 },
    DINNER: { start: 17, end: 29 },
};
